export default "__VITE_ASSET__BJJINTqB__"